module.exports = __webpack_public_path__ + "img/icon4@2x.a3e252f1.png";